import { render, staticRenderFns } from "./Sancionados.vue?vue&type=template&id=b0a6f8f4&scoped=true"
import script from "./Sancionados.vue?vue&type=script&lang=js"
export * from "./Sancionados.vue?vue&type=script&lang=js"
import style0 from "./Sancionados.vue?vue&type=style&index=0&id=b0a6f8f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a6f8f4",
  null
  
)

export default component.exports